import type { WorkspaceMember } from '../types/workspace-member.type'

import { findInviteEmailConflict } from './findInviteEmailConflict'
import type { InviteEmailConflictScope } from './InviteEmailConflictError'
import { InviteEmailConflictError } from './InviteEmailConflictError'

export const assertNoInviteEmailConflict = (
  members: WorkspaceMember[],
  email: string,
  scope: InviteEmailConflictScope
): void => {
  const conflict = findInviteEmailConflict(members, email)
  if (conflict) {
    throw new InviteEmailConflictError(conflict, scope)
  }
}
